import React, { useEffect, useState } from "react";
import { Heart, Repeat } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { getDonorWall } from "../lib/api";

const initials = (name) => {
  const clean = name.replace(/\(.*?\)/g, "").trim();
  const parts = clean.split(/\s+/).filter(Boolean);
  if (!parts.length) return "IS";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const SupporterWall = () => {
  const [wall, setWall] = useState(null);

  useEffect(() => {
    getDonorWall().then(setWall).catch(() => setWall([]));
  }, []);

  if (!wall || wall.length === 0) return null;

  return (
    <section className="py-20 md:py-28 bg-offwhite" data-testid="supporter-wall">
      <div className="container-x">
        <SectionHeading
          eyebrow="Our supporters"
          title="Thank you to those who stand with veterans."
          intro="The people, families, and organizations whose generosity keeps beds open and veterans supported."
        />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {wall.map((d, i) => (
            <Reveal key={`${d.name}-${i}`} delay={Math.min(i, 6) * 0.05} data-testid={`supporter-${i}`}>
              <div className="i-card p-6 flex items-center gap-4 h-full">
                <div className="h-12 w-12 shrink-0 rounded-full bg-navy text-gold flex items-center justify-center font-heading text-sm font-black">
                  {initials(d.name)}
                </div>
                <div className="min-w-0">
                  <div className="font-heading text-base font-bold text-navy truncate">{d.name}</div>
                  <div className="mt-0.5 flex items-center gap-1.5 text-xs text-slate uppercase tracking-wide">
                    {d.frequency === "monthly" ? <Repeat className="h-3.5 w-3.5 text-gold" /> : <Heart className="h-3.5 w-3.5 text-gold" />}
                    {d.frequency === "monthly" ? "Monthly supporter" : "Supporter"}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-10 text-center text-sm text-charcoal/60">Names shown with donor permission. Give and opt in to be listed here.</p>
      </div>
    </section>
  );
};

export default SupporterWall;
